import React from 'react';
import { TranslationListPageContainer } from 'containers';

import './style.scss';

function TranslationListPage() {
  return (
    <div className="tv-assignment-list__container">
      <div className="tv-assignment-list__wrapper">
        <TranslationListPageContainer />
      </div>
    </div>
  );
}

TranslationListPage.propTypes = {};

export default TranslationListPage;
